import React, { Fragment, useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import Rating from "@material-ui/lab/Rating";
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";

import MakeAPICall from "../../apiCalls/common";
import APP_CONSTANTS from "../../constants";

import {
  addBulkBilledIncentiveApiRoute,
  changeDoctorApiRoute,
  changePatientApiRoute,
  checkIfConsultMedicareClaimedAlreadyLoggedApiRoute,
  editConsultDurationApiRoute,
  getSessionByIdApiRoute,
  markSuccessFulApiRoute,
  markUnSuccessFulApiRoute,
  searchPatientsApiRoute,
  updateAdminConnReportMarkApiRoute,
  updateConsultCostApiRoute
} from "../../apiRoutes";

import appRoutes from "../../routes/appRoutes";

import { IMAGES_EXTENSIONS } from "../../constants/constants";

import { getFormattedDate } from "../../utils/dateTimeHelper";

import Loader from "../../components/loader";
import Button from "../../components/button";
import CustomModal from "../../components/modal";
import ICInput from "../../components/form/input";
import ViewProfilePic from "../../components/viewProfilePic";

import ICNoImg from "../../assets/images/default-picture.png";
import medicareImg from "../../assets/images/medicare-button.png";

const ConsultDetailPage = props => {
  let { id } = useParams();

  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [showPicModal, setShowPicModal] = useState(false);
  const [selPic, setSelPic] = useState(ICNoImg);
  const [data, setData] = useState(null);
  const [modalText, setModalText] = useState("");
  const [showTextModal, setShowTextModal] = useState(false);
  const [showUnsuccessfulModal, setShowUnsuccessfulModal] = useState(false);
  const [showConsultChangeModal, setShowConsultChangeModal] = useState(false);
  const [isCodeEditMode, setIsCodeEditMode] = useState(false);
  const [isBulkItemEditMode, setIsBulkItemEditMode] = useState(false);
  const [consultCostVal, setConsultCostVal] = useState(0);
  const [newBulkItemVal, setNewBulkItemVal] = useState(0);
  const [isDurationEditMode, setIsDurationEditMode] = useState(false);
  const [newDurationVal, setNewDurationVal] = useState(0);
  const [showDoctorSelectionModal, setShowDoctorSelectionModal] = useState(false);
  const [filteredDoctors, setFilteredDoctors] = useState([]);
  const [showDoctorConfirmationModal, setShowDoctorConfirmationModal] = useState(false);
  const [showSuccessfulModal, setShowSuccessfulModal] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState({});
  const [showPatientSelectionModal, setShowPatientSelectionModal] = useState(false);
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [showPatientConfirmationModal, setShowPatientConfirmationModal] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState({});
  const [patientSearchText, setPatientSearchText] = useState("");
  const [patientSearchTimeout, setPatientSearchTimeout] = useState(null);
  const [showIncentiveModal, setShowIncentiveModal] = useState(false);
  const [selectedIncentive, setSelectedIncentive] = useState(null);

  const getDetails = () => {
    setIsProcessing(true);

    let params = {
      appointmentId: id
    };

    setApiCallParams({
      reqType: "GET",
      reqUrl: getSessionByIdApiRoute,
      params: params,
      successCallback: res => {
        let data = {};

        if (res.data.data) {
          let driverList = res.data.data;

          if (
            driverList.nurseId &&
            driverList.nurseId !== undefined &&
            driverList.nurseId !== ""
          ) {
            driverList.doctorId = driverList.nurseId;
            driverList.doctorId.doctorId = driverList.nurseId.nurseId;
          } else {
            driverList.doctorId.firstName =
              "Dr. " + driverList.doctorId.firstName;
          }

          if (
            driverList.isPhoneCallUsed !== undefined &&
            driverList.isPhoneCallUsed === true
          ) {
            data.isPhoneCallUsed = true;
          } else {
            data.isPhoneCallUsed = false;
          }

          data._id = driverList._id;

          data.createdAt = getFormattedDate(driverList.createdAt);

          data.markedunsuccess = driverList.markedunsuccess;
          data.consultCost = driverList.appointmentPrice.toFixed(2);
          data.appointmentId = driverList.appointmentId;
          data.PMFeeAmount = driverList.PMFeeAmount.toFixed(2);
          data.doctorEarning = (
            driverList.totalPaidPrice -
            driverList.taxAmount -
            data.PMFeeAmount
          ).toFixed(2);

          data.isBulkIncentiveAdded = false;

          if (
            driverList.isBulkIncentiveAdded !== undefined &&
            driverList.isBulkIncentiveAdded === true
          ) {
            data.isBulkIncentiveAdded = true;
            data.doctorEarning = (
              parseFloat(data.doctorEarning) +
              driverList.bulkIncentiveDetails.price
            ).toFixed(2);
            data.incentiveItemNo = driverList.bulkIncentiveDetails.itemNo;
            data.incentivePrice = (driverList.bulkIncentiveDetails.price).toFixed(2);
          }

          data.taxAmount = driverList.taxAmount.toFixed(2);

          if (driverList.doctorId) {
            data.doctorImage = driverList.doctorId.profilePic
              ? driverList.doctorId.profilePic.original
              : ICNoImg;
            data.doctorAddress =
              driverList.doctorId.address.suburb +
              " " +
              driverList.doctorId.address.state +
              " " +
              driverList.doctorId.address.postCode;

            data.doctorName = driverList.doctorId.firstName;

            if (
              driverList.doctorId.middleName !== null ||
              driverList.doctorId.middleName !== undefined ||
              driverList.doctorId.middleName !== ""
            ) {
              data.doctorName =
                data.doctorName + " " + driverList.doctorId.middleName;
            }

            if (
              driverList.doctorId.lastName !== null ||
              driverList.doctorId.lastName !== undefined ||
              driverList.doctorId.lastName !== ""
            ) {
              data.doctorName =
                data.doctorName + " " + driverList.doctorId.lastName;
            }

            data.doctorUIN = driverList.doctorId.doctorId;
            data.doctorPhoneNumber = driverList.doctorId.phoneNumber;
            data.doctorEmail = driverList.doctorId.email;
            data.bankName = driverList.doctorId.manageAccount.bankAccountName;
            data.bankAccountNo =
              driverList.doctorId.manageAccount.bankAccoutLastFourDigit;
            data.bankAccountName =
              driverList.doctorId.manageAccount.accountHolderName;
            data.bsb = driverList.doctorId.manageAccount.routingNumber;
          } else {
            data.doctorImage = ICNoImg;
            data.doctorAddress = "";
            data.doctorName = "";
            data.doctorUIN = "";
            data.doctorPhoneNumber = "";
            data.doctorEmail = "";
            data.bankName = "";
            data.bankAccountNo = "";
            data.bankAccountName = "";
            data.bsb = "";
          }

          if (driverList.deviceDetails) {
            data.deviceDetails = driverList.deviceDetails;
          } else {
            data.deviceDetails = "";
          }

          if (driverList.patientId != null) {
            data.patientProfile = driverList.patientId.profilePic
              ? driverList.patientId.profilePic.original
              : ICNoImg;
            data.patientName = driverList.patientId.firstName;

            if (
              driverList.patientId.middleName !== null ||
              driverList.patientId.middleName !== undefined ||
              driverList.patientId.middleName !== ""
            ) {
              data.patientName =
                data.patientName + " " + driverList.patientId.middleName;
            }

            if (
              driverList.patientId.lastName !== null ||
              driverList.patientId.lastName !== undefined ||
              driverList.patientId.lastName !== ""
            ) {
              data.patientName =
                data.patientName + " " + driverList.patientId.lastName;
            }

            data.patId = driverList.patientId._id;
            data.patientEmail = driverList.patientId.email;
            data.patientPhoneNumber = driverList.patientId.phoneNumber;
            data.patientUIN = driverList.patientId.patientId;

            data.patientAddress =
              driverList.patientId.address.suburb +
              " " +
              driverList.patientId.address.state +
              " " +
              driverList.patientId.address.postCode;
          } else {
            data.patId = "";
            data.patientProfile = ICNoImg;
            data.patientFirstName = "";
            data.patientMiddleName = "";
            data.patientLastName = "";
            data.patientEmail = "";
            data.patientPhoneNumber = "";
            data.patientUIN = "";
            data.patientAddress = "";
          }

          if (driverList.consultId) {
            data.consultName = driverList.consultId.consultName;
          } else {
            data.consultName = driverList.consultNature;
          }

          data.rating = driverList.rating ? driverList.rating : 0;

          data.comment = driverList.comment;
          if (driverList.comment && driverList.comment != null) {
            data.comment = driverList.comment;
          } else {
            data.comment = "No comments available";
          }

          let x = parseInt(driverList.consultDuration);
          data.totalSeconds = x / 1000;
          data.minutes = parseInt(data.totalSeconds / 60);
          data.seconds = parseInt(data.totalSeconds % 60);
          if (data.minutes === 0 || data.minutes === 1) {
            data.minValue = "min";
          } else {
            data.minValue = "mins";
          }
          if (data.seconds === 0 || data.seconds === 1) {
            data.secValue = "sec";
          } else {
            data.secValue = "secs";
          }

          data.consultImgs = [];
          data.consultDocs = [];

          driverList.consultImgs.forEach(img => {
            if (
              IMAGES_EXTENSIONS.includes(
                img.original.split(".")[img.original.split(".").length - 1]
              )
            ) {
              data.consultImgs.push(img);
            } else {
              data.consultDocs.push(img);
            }
          });

          driverList.consultDocs.forEach(img => {
            if (
              IMAGES_EXTENSIONS.includes(
                img.original.split(".")[img.original.split(".").length - 1]
              )
            ) {
              data.consultImgs.push(img);
            } else {
              data.consultDocs.push(img);
            }
          });

          if (driverList.consultInfo) {
            data.consultInfo = driverList.consultInfo;
          } else {
            data.consultInfo = "No additional information available";
          }

          data.receiptNo = driverList.receiptNo;
          if (driverList.receiptUrl) {
            data.showReciept = true;
            data.receiptUrl = driverList.receiptUrl;
            data.receiptType = driverList.receiptType;
          } else {
            data.showReciept = false;
            data.receiptUrl = "--";
          }
          if (driverList.taxSummary) {
            data.showTaxSum = true;
            data.taxSummary = driverList.taxSummary;
          } else {
            data.showTaxSum = false;
            data.taxSummary = "--";
          }
          if (driverList.paymentSlip) {
            data.showPaymentSlip = true;
            data.paymentSlip = driverList.paymentSlip;
          } else {
            data.showPaymentSlip = false;
            data.paymentSlip = "--";
          }

          data.totalRating = driverList.doctorId
            ? driverList.doctorId.totalRating
            : 0;
          data.ratedCount = driverList.doctorId
            ? driverList.doctorId.ratedCount
            : 0;
          data.docRate = data.ratedCount / data.totalRating;
          if (
            driverList.patientCardId &&
            driverList.patientCardId.lastFourDigit
          ) {
            data.patientCardId = driverList.patientCardId.lastFourDigit;
          }

          data.haveConnectionIssue = driverList.haveConnectionIssue
            ? driverList.haveConnectionIssue
            : false;

          data.isBulkBilled =
            driverList.isBulkBilled === undefined
              ? false
              : driverList.isBulkBilled;

          data.consultDetailMedicareId = driverList.consultDetailMedicareId
            ? driverList.consultDetailMedicareId
            : null;

          data.bbDB4FormLink = driverList.bbDB4FormLink
            ? driverList.bbDB4FormLink
            : "#";

          setNewBulkItemVal(
            driverList.consultDetailMedicareId
              ? driverList.consultDetailMedicareId.mbsItemNo
              : 0
          );

          if (driverList.patientCouponId) {
            data.couponUsed = true;
          } else {
            data.couponUsed = false;
          }

          if (driverList.selectedCovidSituation) {
            data.selectedCovidSituation = (driverList.selectedCovidSituation).replace("hot spot", "impacted area");
          }

          setConsultCostVal(data.consultCost);

          setNewDurationVal(Math.floor(data.totalSeconds));

          setData(data);
        } else {
          setModalText(
            "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
          );
          setShowTextModal(true);
        }

        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };


  const filterDoctors = (e) => {
    if (e.target.value.length < 1) {
      setFilteredDoctors(props.doctorList);
      return;
    }

    setFilteredDoctors(props.doctorList.filter((doctor) =>
      (doctor.firstName.toLowerCase() + " " +
        doctor.middleName.toLowerCase() + " " +
        doctor.lastName.toLowerCase()).includes(e.target.value.toLowerCase()) ||
      doctor.email.toLowerCase().includes(e.target.value.toLowerCase()) ||
      doctor._id.toLowerCase().includes(e.target.value.toLowerCase()) ||
      doctor.doctorId.toLowerCase().includes(e.target.value.toLowerCase())));
  };

  const updateConnectionReportStatus = () => {
    setShowConsultChangeModal(false);
    setIsProcessing(true);

    var formData = new FormData();
    formData.append("appointmentId", data ? data.appointmentId : "");

    setApiCallParams({
      reqType: "POST",
      reqUrl: updateAdminConnReportMarkApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        getDetails();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  const markConsultUnsuccess = () => {
    setShowConsultChangeModal(false);
    setShowUnsuccessfulModal(false);
    setIsProcessing(true);

    // check for bulk billed consult whether they are already claimed or not before procedding with the mark unsuccessfull consult
    if (data.isBulkBilled === true) {
      var formData = new FormData();

      formData.append(
        "consultDate",
        data ? getFormattedDate(data.updatedAt, "YYYY-MM-DD") : ""
      );

      setApiCallParams({
        reqType: "POST",
        reqUrl: checkIfConsultMedicareClaimedAlreadyLoggedApiRoute,
        dataObj: formData,
        successCallback: res => {
          setIsProcessing(false);

          if (res.data.data === "Not Yet Claimed") {
            markConsultUnSuccessful();
          } else {
            setModalText("Claim already lodged with Medicare");
            setShowTextModal(true);
          }
        },
        failureCallback: err => {
          setIsProcessing(false);
          // setModalText(
          //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
          // );
          // setShowTextModal(true);
        }
      });
    } else {
      markConsultUnSuccessful();
    }
  };

  const markConsultSuccess = () => {
    setShowSuccessfulModal(false);
    setIsProcessing(true);
    var formData = new FormData();
    formData.append("appointmentId", data ? data.appointmentId : "");

    setApiCallParams({
      reqType: "POST",
      reqUrl: markSuccessFulApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        getDetails();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  const markConsultUnSuccessful = () => {
    setIsProcessing(true);
    var formData = new FormData();
    formData.append("appointmentId", data ? data.appointmentId : "");

    setApiCallParams({
      reqType: "POST",
      reqUrl: markUnSuccessFulApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        getDetails();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  const applyNewConsultCost = isBulkBilled => {
    let proceed = false;
    let itemCost = consultCostVal;

    if (
      isBulkBilled === false &&
      data.consultCost &&
      data.consultCost !== consultCostVal
    ) {
      proceed = true;
    } else if (
      (data.consultDetailMedicareId &&
        data.consultDetailMedicareId.mbsItemNo !== newBulkItemVal) ||
      data.consultDetailMedicareId === undefined ||
      data.consultDetailMedicareId === null
    ) {
      proceed = true;
      itemCost = newBulkItemVal;
    }

    if (proceed === true) {
      setIsCodeEditMode(false);
      setIsBulkItemEditMode(false);
      setIsProcessing(true);

      var formData = new FormData();
      formData.append("appointmentId", data ? data.appointmentId : "");
      formData.append("newConsultCost", itemCost);
      formData.append("isBulkBilled", isBulkBilled);

      setApiCallParams({
        reqType: "PUT",
        reqUrl: updateConsultCostApiRoute,
        dataObj: formData,
        successCallback: res => {
          setIsProcessing(false);
          setModalText("Consult Details Updated Successfully");
          setShowTextModal(true);
          getDetails();
        },
        failureCallback: err => {
          setIsProcessing(false);

          if (err.message === "This MBS Item Number does not exists.") {
            setModalText("This MBS Item Number does not exists.");
          } else if (err && err.message) {
            setModalText(err.message);
          } else {
            setModalText(
              "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
            );
          }

          setShowTextModal(true);

          setConsultCostVal(data.consultCost);
          setNewBulkItemVal(
            data.consultDetailMedicareId
              ? data.consultDetailMedicareId.mbsItemNo
              : 0
          );
        },
        showErrPopup: false
      });
    }
  };

  const applyNewConsultDuration = () => {
    setIsDurationEditMode(false);
    setIsProcessing(true);

    var formData = new FormData();
    formData.append("appointmentId", data ? data._id : "");
    formData.append("consultDuration", newDurationVal);

    setApiCallParams({
      reqType: "POST",
      reqUrl: editConsultDurationApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Consult Duration Updated Successfully");
        setShowTextModal(true);
        getDetails();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  useEffect(() => {
    getDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showSelPicModal = pic => {
    setSelPic(pic);
    setShowPicModal(true);
  };

  const toggleUnsuccessfulModal = e => {
    setShowUnsuccessfulModal(!showUnsuccessfulModal);
  };

  const toggleSuccessfulModal = e => {
    setShowSuccessfulModal(!showSuccessfulModal);
  };

  const handleCostEditChange = e => {
    setConsultCostVal(e.target.value);
  };

  const handleBulkItemEditChange = e => {
    setNewBulkItemVal(e.target.value);
  };

  const handleDurationEditChange = e => {
    setNewDurationVal(e.target.value);
  };

  const openPatientDetails = pat => {
    const auth = props.auth.user;
    window.open(
      APP_CONSTANTS.pmsURL +
      "/patient/patientDetails?accessToken=" +
      auth.accessToken +
      "&patientId=" +
      pat.id +
      "&searchType=" +
      auth.userType +
      "&adminName=" +
      auth.firstName +
      " " +
      auth.lastName,
      "_blank"
    );
  };

  const selectDoctor = (doctor) => {
    setSelectedDoctor(doctor);
    setShowDoctorConfirmationModal(true);
  };

  const apiCallToUpdateDoctor = () => {
    setShowDoctorConfirmationModal(false);
    setShowDoctorSelectionModal(false);
    setIsProcessing(true);
    let formData = {
      "appointmentId": data._id,
      "doctorId": selectedDoctor._id
    };

    setApiCallParams({
      reqType: "POST",
      reqUrl: changeDoctorApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Doctor updated successfully");
        setShowTextModal(true);
        getDetails();
      },
      failureCallback: err => {
        setModalText(err.message);
        setShowTextModal(true);
        setIsProcessing(false);
      }
    });
  };

  const handleDoctorClick = () => {
    console.log(props.doctorList);
    console.log(filteredDoctors);
    setFilteredDoctors(props.doctorList);
    setShowDoctorSelectionModal(true);
  };

  const searchPatients = (searchText) => {
    if (!searchText || searchText.trim().length === 0) {
      setFilteredPatients([]);
      return;
    }

    setIsProcessing(true);

    setApiCallParams({
      reqType: "GET",
      reqUrl: searchPatientsApiRoute,
      params: { searchParam: searchText },
      successCallback: res => {
        setIsProcessing(false);
        if (res.data && res.data.data && res.data.data.patients) {
          setFilteredPatients(res.data.data.patients);
        }
      },
      failureCallback: err => {
        setIsProcessing(false);
        setFilteredPatients([]);
      }
    });
  };

  const filterPatients = (e) => {
    const searchText = e.target.value;
    setPatientSearchText(searchText);

    // Clear previous timeout
    if (patientSearchTimeout) {
      clearTimeout(patientSearchTimeout);
    }

    // If search text is empty, clear results immediately
    if (!searchText || searchText.trim().length === 0) {
      setFilteredPatients([]);
      return;
    }

    // Debounce the search with 1 second delay
    const timeout = setTimeout(() => {
      searchPatients(searchText);
    }, 1000);

    setPatientSearchTimeout(timeout);
  };

  const selectPatient = (patient) => {
    setSelectedPatient(patient);
    setShowPatientConfirmationModal(true);
  };

  const apiCallToUpdatePatient = () => {
    setShowPatientConfirmationModal(false);
    setShowPatientSelectionModal(false);
    setIsProcessing(true);

    setApiCallParams({
      reqType: "POST",
      reqUrl: changePatientApiRoute,
      params: {
        appointmentId: data._id,
        currentPatientId: data.patId,
        newPatientId: selectedPatient._id,
        isDependent: selectedPatient.isDependent || false
      },
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Patient updated successfully");
        setShowTextModal(true);
        getDetails();
      },
      failureCallback: err => {
        setModalText(err.message || "Error updating patient");
        setShowTextModal(true);
        setIsProcessing(false);
      }
    });
  };

  const handlePatientClick = () => {
    setPatientSearchText("");
    setFilteredPatients([]);
    setShowPatientSelectionModal(true);
  };

  // Bulk Incentive Functions
  const shouldShowIncentiveButton = () => {
    if (!data) return false;
    if (!data.isBulkBilled) return false;
    if (data.isBulkIncentiveAdded) return true;

    const createdTimestamp = new Date(data.createdAtDate).getTime();
    const currentTimestamp = new Date().getTime();
    const endAddIncentiveTimestamp = createdTimestamp + 28 * 60 * 60 * 1000;
    const consultDate = new Date(data.createdAtDate);
    const todayDate = new Date();
    const isSameDay = consultDate.toDateString() === todayDate.toDateString();
    const isWithin28Hours = currentTimestamp < endAddIncentiveTimestamp;

    return isSameDay || isWithin28Hours;
  };

  const getFilteredIncentives = () => {
    const incentives = props.serverConstants?.constants?.icMBSItemIncentives;

    if (!data || !incentives) {
      return [];
    }

    const currentMBSItemNo = data.consultDetailMedicareId?.mbsItemNo;

    // If no MBS item is set, show all incentives
    if (!currentMBSItemNo) {
      return incentives;
    }

    let currentFeeNote = data.consultDetailMedicareId?.incentiveGroup || '';

    if (!currentFeeNote && currentMBSItemNo) {
      const matchingIncentive = incentives.find(
        incentive => incentive.mbsItemNo === String(currentMBSItemNo)
      );
      if (matchingIncentive) {
        currentFeeNote = matchingIncentive.feeNote || '';
      }
    }

    const filtered = currentFeeNote
      ? incentives.filter(incentive => incentive.feeNote === currentFeeNote)
      : incentives;

    return filtered;
  };

  const handleAddIncentive = () => {
    if (!data) {
      setModalText("Consult data not available");
      setShowTextModal(true);
      return;
    }

    if (!data.isBulkBilled) {
      setModalText("This consult must be bulk billed to add an incentive");
      setShowTextModal(true);
      return;
    }

    if (!data.isBulkIncentiveAdded) {
      const createdTimestamp = new Date(data.createdAtDate).getTime();
      const currentTimestamp = new Date().getTime();
      const endAddIncentiveTimestamp = createdTimestamp + 28 * 60 * 60 * 1000;
      const consultDate = new Date(data.createdAtDate);
      const todayDate = new Date();
      const isSameDay = consultDate.toDateString() === todayDate.toDateString();
      const isWithin28Hours = currentTimestamp < endAddIncentiveTimestamp;

      if (!isSameDay && !isWithin28Hours) {
        setModalText("Incentives can only be added on the same day or within 28 hours of the consultation");
        setShowTextModal(true);
        return;
      }
    }

    // Preselect current incentive if already added
    if (data.isBulkIncentiveAdded && data.incentiveItemNo) {
      const currentIncentive = getFilteredIncentives().find(
        incentive => incentive.mbsItemNo === String(data.incentiveItemNo)
      );
      if (currentIncentive) {
        setSelectedIncentive(currentIncentive);
      }
    }

    setShowIncentiveModal(true);
  };

  const handleIncentiveSelect = (incentive) => {
    setSelectedIncentive(incentive);
  };

  const apiCallToAddIncentive = () => {
    if (!data) {
      setModalText("Consult data not available");
      setShowTextModal(true);
      return;
    }

    if (!selectedIncentive) {
      setModalText("Please select an incentive");
      setShowTextModal(true);
      return;
    }

    setShowIncentiveModal(false);
    setIsProcessing(true);

    setApiCallParams({
      reqType: "PUT",
      reqUrl: addBulkBilledIncentiveApiRoute,
      params: {
        appointmentId: data._id,
        incentiveItemNo: selectedIncentive.mbsItemNo,
        incentiveDescription: selectedIncentive.description,
        incentivePrice: selectedIncentive.amount
      },
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Bulk incentive added successfully");
        setShowTextModal(true);
        setSelectedIncentive(null);
        getDetails();
      },
      failureCallback: err => {
        setModalText(err.message || "Error adding bulk incentive");
        setShowTextModal(true);
        setIsProcessing(false);
      }
    });
  };

  return (
    <Fragment>
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <div className="view-ticket-container">
          <CustomModal
            useOneButton={true}
            cancelText="OKAY"
            openModal={showTextModal}
            cancelEvent={() => {
              setShowTextModal(false);
              setModalText("");
            }}
            modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
          />
          <CustomModal
            openModal={showPicModal}
            cancelEvent={() => {
              setShowPicModal(false);
              setSelPic(ICNoImg);
            }}
            title="View Image"
            modalBodyContent={<ViewProfilePic profileImg={selPic} />}
            noFooterButtons={true}
          />
          <CustomModal
            okayText="Confirm"
            cancelText="Cancel"
            openModal={showUnsuccessfulModal}
            cancelEvent={toggleUnsuccessfulModal}
            okayEvent={markConsultUnsuccess}
            modalBodyContent={
              <p className="text-center mb-0">
                Are you sure you want to mark this as an unsuccessful consult?
              </p>
            }
          />

          <CustomModal
            cancelText="Cancel"
            okayText="Confirm"
            openModal={showDoctorConfirmationModal}
            cancelEvent={() => setShowDoctorConfirmationModal(false)}
            okayEvent={apiCallToUpdateDoctor}
            modalBodyContent={
              <p className="text-center mb-0">
                Are you sure you want to change doctor from
                "{(data || {}).doctorUIN} | {(data || {}).doctorName}" to
                "{(selectedDoctor || {}).doctorId} | {selectedDoctor.firstName + " " +
                (selectedDoctor.middleName ? selectedDoctor.middleName + " " : "")
                + selectedDoctor.lastName}"?
              </p>
            }
          />

          <CustomModal
            okayText="Confirm"
            cancelText="Cancel"
            openModal={showSuccessfulModal}
            cancelEvent={toggleSuccessfulModal}
            okayEvent={markConsultSuccess}
            modalBodyContent={
              <p className="text-center mb-0">
                Are you sure you want to mark this as a successful consult?
              </p>
            }
          />

          <CustomModal
            useOneButton={true}
            // okayEvent={markConsultSuccess}
            openModal={showDoctorSelectionModal}
            cancelText="Cancel"
            title="Select Doctor"
            cancelEvent={() => setShowDoctorSelectionModal(false)}
            modalBodyContent={
              <>
                <div
                  style={{ width: "80%", background: "white", marginLeft: "10%" }}
                  className="search-pr-box-container input-group position-relative mb-3 mt-0"
                >
                  <div className="input-group-prepend">
                    <span className="input-group-text search-icon">
                    <i className="fas fa-search"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control doctor-search-bar"
                    placeholder="Search by name, email or UIN"
                    onChange={filterDoctors}
                  />
                </div>

                <div className="doctor-selection-dialog">
                  {filteredDoctors.map((doctor, index) => (
                    <div className="m-1 clickable" key={index} onClick={() => selectDoctor(doctor)}>
                      <img
                        className="rounded-circle user-img inline m-1"
                        src={doctor.profilePic.original || doctor.profilePic.thumb}
                        alt="user-img"
                      />
                      <div className="inline m-2 mtb-auto" style={{ display: "inline-block" }}>
                        <p className="m-1">
                          <b>{doctor.firstName + " " +
                            (doctor.middleName ? doctor.middleName + " " : "")
                            + doctor.lastName}</b>
                        </p>
                        <p className="m-1">{doctor.doctorId}</p>
                      </div>
                      {
                        index !== props.doctorList.length - 1 && (
                          <div className="my-1" style={{ width: "100%", height: "1px", background: "lightgray" }}></div>)
                      }
                    </div>
                  ))}
                </div>
              </>
            }
          />

          <CustomModal
            cancelText="Cancel"
            okayText="Confirm"
            openModal={showPatientConfirmationModal}
            cancelEvent={() => setShowPatientConfirmationModal(false)}
            okayEvent={apiCallToUpdatePatient}
            modalBodyContent={
              <p className="text-center mb-0">
                Are you sure you want to change patient from
                "{(data || {}).patientUIN} | {(data || {}).patientName}" to
                "{(selectedPatient || {}).patientId} | {selectedPatient.firstName + " " +
                (selectedPatient.middleName ? selectedPatient.middleName + " " : "")
                + selectedPatient.lastName}"?
              </p>
            }
          />

          <CustomModal
            useOneButton={true}
            openModal={showPatientSelectionModal}
            cancelText="Cancel"
            title="Select Patient"
            cancelEvent={() => setShowPatientSelectionModal(false)}
            modalBodyContent={
              <>
                <div
                  style={{ width: "80%", background: "white", marginLeft: "10%" }}
                  className="search-pr-box-container input-group position-relative mb-3 mt-0"
                >
                  <div className="input-group-prepend">
                    <span className="input-group-text search-icon">
                    <i className="fas fa-search"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control doctor-search-bar"
                    placeholder="Search by name, email or UIN"
                    value={patientSearchText}
                    onChange={filterPatients}
                  />
                </div>

                <div className="doctor-selection-dialog">
                  {filteredPatients.map((patient, index) => (
                    <div className="m-1 clickable" key={index} onClick={() => selectPatient(patient)}>
                      <img
                        className="rounded-circle user-img inline m-1"
                        src={patient.profilePic ? (patient.profilePic.original || patient.profilePic.thumb) : ICNoImg}
                        alt="user-img"
                      />
                      <div className="inline m-2 mtb-auto" style={{ display: "inline-block" }}>
                        <p className="m-1">
                          <b>{patient.firstName + " " +
                            (patient.middleName ? patient.middleName + " " : "")
                            + patient.lastName}</b>
                        </p>
                        <p className="m-1">{patient.patientId}</p>
                      </div>
                      {
                        index !== filteredPatients.length - 1 && (
                          <div className="my-1" style={{ width: "100%", height: "1px", background: "lightgray" }}></div>)
                      }
                    </div>
                  ))}
                </div>
              </>
            }
          />

          <CustomModal
            cancelText="Cancel"
            okayText={data && data.isBulkIncentiveAdded ? "Update Incentive" : "Add Incentive"}
            openModal={showIncentiveModal}
            cancelEvent={() => {
              setShowIncentiveModal(false);
              setSelectedIncentive(null);
            }}
            okayEvent={apiCallToAddIncentive}
            title="Select Bulk Billed Incentive"
            modalBodyContent={
              <>
                <div className="mb-3">
                  <p>Select an MBS incentive item to add to this consultation:</p>
                  {data && data.medicareConcessionCardCheckBox && (
                    <p className="text-info"><i className="fas fa-info-circle"></i> Patient is a Concession Card Holder</p>
                  )}
                </div>
                <div className="doctor-selection-dialog" style={{ maxHeight: "400px", overflowY: "auto" }}>
                  {getFilteredIncentives().map((incentive, index) => (
                    <div
                      className="m-2 p-2 clickable"
                      key={index}
                      onClick={() => handleIncentiveSelect(incentive)}
                      style={{
                        borderRadius: "5px",
                        cursor: "pointer",
                        border: selectedIncentive && selectedIncentive.mbsItemNo === incentive.mbsItemNo ? "2px solid #f5ab35" : "1px solid #dee2e6"
                      }}
                    >
                      <div>
                        <p className="m-1">
                          <b>MBS Item No: {incentive.mbsItemNo}</b>
                        </p>
                        <p className="m-1">Amount: ${incentive.amount}</p>
                        <p className="m-1">{incentive.description}</p>
                      </div>
                      {index !== getFilteredIncentives().length - 1 && (
                        <div className="my-2" style={{ width: "100%", height: "1px", background: "lightgray" }}></div>
                      )}
                    </div>
                  ))}
                  {getFilteredIncentives().length === 0 && (
                    <p className="text-center">No MBS incentive items available for this consultation's MBS item</p>
                  )}
                </div>
              </>
            }
          />

          <CustomModal
            noFooterButtons={true}
            openModal={showConsultChangeModal}
            cancelEvent={() => setShowConsultChangeModal(false)}
            title="Change to"
            modalBodyContent={
              <p className="text-center mt-4 mb-0 d-flex flex-row justify-content-center">
                <Button
                  className="ic-btn-green"
                  clickEvent={updateConnectionReportStatus}
                  title="Successful Consult"
                  type="button"
                />
                &nbsp;&nbsp;
                <Button
                  className="ic-btn-red"
                  clickEvent={markConsultUnsuccess}
                  title="Unsuccessful Consult"
                  type="button"
                />
              </p>
            }
          />
          <NavLink
            to={{
              pathname: appRoutes.pastConsults,
              state: {
                currPageNo:
                  props.location.state && props.location.state.currPageNo
                    ? props.location.state.currPageNo
                    : null
              }
            }}
            className="details-back-link"
            href="#"
          >
            <i className="fas fa-arrow-left"></i>{" "}
            <span className="ml-1 back-btn-text"> Back to Past Consults</span>
          </NavLink>
          <h3 className="mt-4">Consult Details</h3>
          <br />
          {data !== null && (
            <div className="consult-details-container">
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <b>Date:</b> <span>{data.createdAt}</span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <b>Consult ID:</b> <span>{data.appointmentId}</span>
                  </p>
                </div>
                <div className="col-md-12">
                  <hr />
                </div>
                <div className="col-md-6">
                  <p>
                    <b>Consult Cost:</b>&nbsp;
                    <span>
                      ${isCodeEditMode === false && data.consultCost}
                      &nbsp;
                      {isCodeEditMode === true && (
                        <ICInput
                          style={{ width: "20%" }}
                          name="consutCost"
                          type="number"
                          onChange={handleCostEditChange}
                          value={consultCostVal}
                        />
                      )}
                    </span>
                    {isCodeEditMode === false && data.isBulkBilled === false && (
                      <button
                        type="button"
                        className="btn btn-out-bell high-z-index ml-2 consult-cost-edit-btns"
                        onClick={() => {
                          setIsCodeEditMode(true);
                        }}
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                    )}
                    {isCodeEditMode === true && (
                      <Fragment>
                        <button
                          type="button"
                          className="btn btn-out-bell high-z-index ml-2 consult-cost-edit-btns"
                          onClick={() => applyNewConsultCost(false)}
                        >
                          <i className="fas fa-save"></i>
                        </button>
                        &nbsp;
                        <button
                          type="button"
                          className="btn btn-out-bell high-z-index ml-2 consult-cost-edit-btns"
                          onClick={() => {
                            setIsCodeEditMode(false);
                            setConsultCostVal(data.consultCost);
                          }}
                        >
                          <i className="fas fa-times"></i>
                        </button>
                      </Fragment>
                    )}
                    <span className="ml-4 color-navy-blue">
                      {data.couponUsed === true ? "Coupon Redeemed" : ""}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  {data.markedunsuccess === true && (
                    <button
                      // disabled
                      className="btn btn-consult-unsuccessful btn-consult-unsuccessful-marked"
                      onClick={toggleSuccessfulModal}
                    >
                      Marked as Unsuccessful Consult
                    </button>
                  )}
                  {data.markedunsuccess === false &&
                    data.haveConnectionIssue !== true && (
                      <button
                        onClick={toggleUnsuccessfulModal}
                        className="btn btn-consult-unsuccessful"
                      >
                        Mark as Unsuccessful Consult
                      </button>
                    )}
                  {data.markedunsuccess === false &&
                    data.haveConnectionIssue === true && (
                      <button
                        onClick={() => setShowConsultChangeModal(true)}
                        className="btn btn-consult-unsuccessful"
                      >
                        Connection Issue Reported
                      </button>
                    )}
                </div>
                <div className="col-md-12">
                  <hr />
                </div>
                {data.isBulkBilled === true && (
                  <Fragment>
                    <div className="col-md-6">
                      <p>
                        <b>MBS Item Number:</b>{" "}
                        <span>
                          {isBulkItemEditMode === false &&
                          data.consultDetailMedicareId
                            ? data.consultDetailMedicareId.mbsItemNo
                            : ""}
                          &nbsp;
                          {isBulkItemEditMode === true && (
                            <ICInput
                              style={{ width: "20%" }}
                              name="bulkItemNo"
                              type="number"
                              onChange={handleBulkItemEditChange}
                              value={newBulkItemVal}
                            />
                          )}
                        </span>
                        {isBulkItemEditMode === false && (
                          <button
                            type="button"
                            className="btn btn-out-bell high-z-index ml-2 consult-cost-edit-btns"
                            onClick={() => {
                              setIsBulkItemEditMode(true);
                            }}
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                        )}
                        {isBulkItemEditMode === true && (
                          <Fragment>
                            <button
                              type="button"
                              className="btn btn-out-bell high-z-index ml-2 consult-cost-edit-btns"
                              onClick={() => applyNewConsultCost(true)}
                            >
                              <i className="fas fa-save"></i>
                            </button>
                            &nbsp;
                            <button
                              type="button"
                              className="btn btn-out-bell high-z-index ml-2 consult-cost-edit-btns"
                              onClick={() => {
                                setIsBulkItemEditMode(false);
                                setNewBulkItemVal(
                                  data.consultDetailMedicareId
                                    ? data.consultDetailMedicareId.mbsItemNo
                                    : ""
                                );
                              }}
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          </Fragment>
                        )}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex flex-row">
                        <img
                          style={{ height: "25px" }}
                          src={medicareImg}
                          alt="medicare-logo"
                        />
                        <p>
                          {data.bbDB4FormLink === "#" && (
                            <span className="ml-2">
                              No Bulk-Bill Assignment of Benefit Form DB4
                              Available
                            </span>
                          )}
                          {data.bbDB4FormLink !== "#" && (
                            <a
                              className="insta-link-orange ml-2"
                              href={data.bbDB4FormLink}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Bulk-Bill Assignment of Benefit Form DB4
                            </a>
                          )}
                        </p>
                      </div>
                      <p className="mt-2">
                        <span style={{ fontSize: "12px" }}>
                          {data.selectedCovidSituation}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-12">
                      <hr />
                    </div>
                    <div className="col-md-12">
                      <p>
                        <b>Bulk Billed Incentive:</b>{" "}
                        <span>
                          {data.isBulkIncentiveAdded ? (
                            <>
                              {data.incentiveItemNo} - ${data.incentivePrice}
                              {data.incentiveDescription && ` - ${data.incentiveDescription}`}
                            </>
                          ) : (
                            "Not Added"
                          )}
                          &nbsp;
                        </span>
                        {shouldShowIncentiveButton() && (
                          <button
                            type="button"
                            className="btn btn-out-bell high-z-index ml-2 consult-cost-edit-btns"
                            onClick={handleAddIncentive}
                            title={data.isBulkIncentiveAdded ? "Edit Bulk Billed Incentive" : "Add Bulk Billed Incentive"}
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                        )}
                      </p>
                    </div>
                    <div className="col-md-12">
                      <hr />
                    </div>
                  </Fragment>
                )}
                <div className="col-md-6">
                  <p>
                    <b>Practice Management Fee:</b>{" "}
                    <span>${data.PMFeeAmount}</span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <b>GST on Practice Management Fee:</b>{" "}
                    <span>${data.taxAmount}</span>
                  </p>
                </div>
                <div className="col-md-12">
                  <hr />
                </div>
                <div className="col-md-6">
                  <p>
                    <b>Doctor’s Earnings:</b> <span>${data.doctorEarning}</span>
                  </p>
                </div>
                <div className="col-md-6 d-flex flex-row">
                  <p>
                    <b>Star Rating:</b>
                  </p>
                  <Box
                    className="ml-2"
                    component="fieldset"
                    borderColor="transparent"
                  >
                    <Rating name="rating" value={data.rating} readOnly />
                  </Box>
                </div>
                <div className="col-md-12">
                  <hr />
                </div>
                <div className="col-md-12">
                  <p>
                    <b>Star Rating Comments</b>
                  </p>
                  <br />
                  <p>{data.comment}</p>
                </div>
                <div className="col-md-12">
                  <hr />
                </div>
                <div className="col-md-12">
                  <p className="mb-2">
                    <b>Practitioner’s Details</b>
                  </p>
                  <div className="d-flex flex-row clickable" onClick={handleDoctorClick}>
                    <img
                      className="rounded-circle user-img mr-4"
                      src={data.doctorImage}
                      alt="user-img"
                    />
                    <div className="d-flex flex-column">
                      <p>
                        <span>{data.doctorName}</span>
                      </p>
                      <p>
                        <b className="opacity-6">UIN:</b>{" "}
                        <span>{data.doctorUIN}</span>
                      </p>
                      <p>
                        <span>{data.doctorAddress}</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <hr />
                </div>
                <div className="col-md-12">
                  <p className="mb-2">
                    <b>Practitioner’s Deposited Earnings</b>
                  </p>
                  <div className="row">
                    <div className="col-md-6">
                      <p>
                        <b className="opacity-6">Bank Account Name:</b>{" "}
                        <span>{data.bankAccountName}</span>
                      </p>
                      <p>
                        <b className="opacity-6">Bank Account BSB:</b>{" "}
                        <span>{data.bsb}</span>
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <b className="opacity-6">Bank Account Number:</b>{" "}
                        <span>{data.bankAccountNo}</span>
                      </p>
                      <p>
                        <b className="opacity-6">Bank Name:</b>{" "}
                        <span>{data.bankName}</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <hr />
                </div>
                <div className="col-md-6">
                  <p className="mb-2">
                    <b>Patient's Details</b>
                  </p>
                  <div className="d-flex flex-row clickable" onClick={handlePatientClick}>
                    <img
                      className="rounded-circle user-img mr-4"
                      src={data.patientProfile}
                      alt="user-img"
                    />
                    <div className="d-flex flex-column">
                      <p>
                        <span>{data.patientName}</span>
                      </p>
                      <p>
                        <b className="opacity-6">UIN:</b>{" "}
                        <span>
                          <a
                            className="pat-pms-custom-link"
                            onClick={e => {
                              e.stopPropagation();
                              openPatientDetails({
                                id: data.patId
                              });
                            }}
                            href="#"
                          >
                            {data.patientUIN}
                          </a>
                        </span>
                      </p>
                      <p>
                        <span>{data.patientAddress}</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <p className="mb-2">
                    <b>Patient’s Payment Method</b>
                  </p>
                  {data.patientCardId && (
                    <p>
                      <b className="opacity-6">Credit Card Number:</b>{" "}
                      <span>XXXX-XXXX-XXXX-{data.patientCardId}</span>
                    </p>
                  )}
                  {!data.patientCardId && (
                    <p>
                      <span>No Card Available</span>
                    </p>
                  )}
                </div>
                <div className="col-md-12">
                  <hr />
                </div>
                <div className="col-md-12">
                  <p>
                    <b>Method of Consult:</b>{" "}
                    <span>
                      {data.isPhoneCallUsed === true
                        ? "Phone Call"
                        : "Video Call"}
                    </span>
                  </p>
                </div>
                <div className="col-md-12">
                  <hr />
                </div>
                <div className="col-md-6">
                  <p>
                    <b>Nature of Consult:</b> <span>{data.consultName}</span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <b>Duration of Consult:</b>{" "}
                    {isDurationEditMode === false && (
                      <span>
                        {data.minutes}
                        {data.minValue}&nbsp;{data.seconds}
                        {data.secValue}
                      </span>
                    )}
                    &nbsp;
                    {isDurationEditMode === true && (
                      <Fragment>
                        <ICInput
                          style={{ width: "20%" }}
                          name="newDuration"
                          type="number"
                          onChange={handleDurationEditChange}
                          value={newDurationVal}
                        />
                        &nbsp;secs
                      </Fragment>
                    )}
                    {isDurationEditMode === false && (
                      <button
                        type="button"
                        className="btn btn-out-bell high-z-index ml-2 consult-cost-edit-btns"
                        onClick={() => {
                          setIsDurationEditMode(true);
                        }}
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                    )}
                    {isDurationEditMode === true && (
                      <Fragment>
                        <button
                          type="button"
                          className="btn btn-out-bell high-z-index ml-2 consult-cost-edit-btns"
                          onClick={() => applyNewConsultDuration(false)}
                        >
                          <i className="fas fa-save"></i>
                        </button>
                        &nbsp;
                        <button
                          type="button"
                          className="btn btn-out-bell high-z-index ml-2 consult-cost-edit-btns"
                          onClick={() => {
                            setIsDurationEditMode(false);
                            setNewDurationVal(data.totalSeconds);
                          }}
                        >
                          <i className="fas fa-times"></i>
                        </button>
                      </Fragment>
                    )}
                  </p>
                </div>
                <div className="col-md-12">
                  <hr />
                </div>
                <div className="col-md-12 row">
                  <p className="mb-2 col-md-12">
                    <b>Images</b>
                  </p>
                  {data.consultImgs.length === 0 && (
                    <p className="col-md-12">
                      <span>No Images available</span>
                    </p>
                  )}
                  {data.consultImgs.map((img, index) => (
                    <div key={index} className="col-md-3">
                      <img
                        className="consult-attached-img"
                        onClick={() => {
                          showSelPicModal(img.original);
                        }}
                        src={img.original}
                        alt="attchment-img"
                      />
                    </div>
                  ))}
                </div>
                <div className="col-md-12">
                  <hr />
                </div>
                <div className="col-md-12 row">
                  <p className="mb-2 col-md-12">
                    <b>Documents</b>
                  </p>
                  {data.consultDocs.length === 0 && (
                    <p className="col-md-12">
                      <span>No Documents available</span>
                    </p>
                  )}
                  {data.consultDocs.map((doc, index) => (
                    <div key={index} className="col-md-3">
                      <p className="font-col-primary">
                        <a
                          className="font-col-primary"
                          href={doc.original}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Document {index + 1}
                        </a>
                      </p>
                    </div>
                  ))}
                </div>
                <div className="col-md-12">
                  <hr />
                </div>
                <div className="col-md-12">
                  <p className="mb-2">
                    <b>Additional Information</b>
                  </p>
                  <p>
                    <span>{data.consultInfo}</span>
                  </p>
                </div>
                <div className="col-md-12">
                  <hr />
                </div>
                <div className="col-md-12">
                  <p className="mb-2">
                    <b>Device Information</b>
                  </p>
                  {data.deviceDetails.browser_name && (
                    <p className="mb-0">
                      <b className="opacity-6">Operating System:</b>{" "}
                      {data.deviceDetails.device_model || "-"}
                      <br />
                      <b className="opacity-6">OS Version:</b>{" "}
                      {data.deviceDetails.os_version || "-"}
                      <br />
                      <b className="opacity-6">Browser Name:</b>{" "}
                      {data.deviceDetails.browser_name || "-"}
                      <br />
                      <b className="opacity-6">Browser Version:</b>{" "}
                      {data.deviceDetails.app_version || "-"}
                    </p>
                  )}
                  {!data.deviceDetails.browser_name && (
                    <p className="mb-0">
                      <b className="opacity-6">Device Model:</b>{" "}
                      {data.deviceDetails.device_model || "-"}
                      <br />
                      <b className="opacity-6">Operating System:</b>{" "}
                      {data.deviceDetails.os_name || "-"}
                      <br />
                      <b className="opacity-6">OS Version:</b>{" "}
                      {data.deviceDetails.os_version || "-"}
                      <br />
                      <b className="opacity-6">App Version:</b>{" "}
                      {data.deviceDetails.app_version || "-"}
                    </p>
                  )}
                </div>
                <div className="col-md-12">
                  <hr />
                </div>
                <div className="col-md-4">
                  {(!data.showReciept ||
                    (data.isBulkBilled !== undefined &&
                      data.isBulkBilled === true)) && (
                    <p className="font-col-primary">Receipt Not Available</p>
                  )}
                  {data.showReciept &&
                    (data.isBulkBilled === undefined ||
                      data.isBulkBilled === false) && (
                      <p className="font-col-primary">
                        <a
                          className="font-col-primary"
                          href={data.receiptUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View {data.receiptType}
                        </a>
                      </p>
                    )}
                </div>
                <div className="col-md-4">
                  {!data.showPaymentSlip && (
                    <p className="font-col-primary">
                      Consult Payment Summary Not Available
                    </p>
                  )}
                  {data.showPaymentSlip && (
                    <p className="font-col-primary">
                      <a
                        className="font-col-primary"
                        href={data.paymentSlip}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Consult Payment Summary
                      </a>
                    </p>
                  )}
                </div>
                <div className="col-md-4">
                  {!data.showTaxSum && (
                    <p className="font-col-primary">
                      Consult Tax Invoice Not Available
                    </p>
                  )}
                  {data.showTaxSum && (
                    <p className="font-col-primary">
                      <a
                        className="font-col-primary"
                        href={data.taxSummary}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Consult Tax Invoice
                      </a>
                    </p>
                  )}
                </div>
                <div className="col-md-12">
                  <hr />
                </div>
              </div>
            </div>
          )}
          <br />
          <br />
        </div>
      </div>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
    </Fragment>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
  doctorList: state.serverConstants.doctorAndNurseList,
  serverConstants: state.serverConstants
});

export default connect(mapStateToProps, null)(ConsultDetailPage);
